import React from "react";
import NimbusLinkCard from "../../../ui-components/nimbus-link-card/nimbus-link-card";

const NimbusDeveloperToolsIndex = () => {
  return (
    <div className="flex flex-wrap p-2 gap-2 justify-center ">
      <NimbusLinkCard
        title={"API Hitters"}
        to={"/nimbus/developer-tools/api-hitters"}
        icon="fa-code"
      />
      <NimbusLinkCard
        title={"One-off Scripts"}
        to={"/nimbus/developer-tools/one-off-scripts"}
        icon="fa-terminal"
      />
      <NimbusLinkCard
        title="Query Database"
        to="/nimbus/developer-tools/database"
        icon="fa-database"
      />
      <NimbusLinkCard
        title="Emails"
        to="/nimbus/developer-tools/emails"
        icon="fa-paper-plane"
      />
    </div>
  );
};

export default NimbusDeveloperToolsIndex;
